import script from "./FrSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrSelect.vue?vue&type=script&setup=true&lang=ts"

import "./FrSelect.vue?vue&type=style&index=0&id=079d425c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079d425c"]])

export default __exports__